import { render, staticRenderFns } from "./AppealsListPage.vue?vue&type=template&id=25d6ad8e&scoped=true&"
import script from "./AppealsListPage.vue?vue&type=script&lang=js&"
export * from "./AppealsListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d6ad8e",
  null
  
)

export default component.exports